export {
  default as swimmingLanes,
  ReactComponent as SwimmingLanes,
} from '@assets/icons/features-and-amenities/swimming-lanes.svg'    
